import { render, staticRenderFns } from "./KeyPoints.vue?vue&type=template&id=8a9c9296&"
import script from "./KeyPoints.vue?vue&type=script&lang=js&"
export * from "./KeyPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports